import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RestResponse } from '../../models/restResponse.mode';
import { Promotion, SavePromotionPayload } from '../../models/promotion.model';

@Injectable({
  providedIn: 'root'
})
export class PromotionService {
  private readonly baseUrl = `${environment.base_url}/promotions`;

  constructor(private http: HttpClient) {}

  getAll(search: string, page: number, paginate = true): Observable<RestResponse<Promotion[]>> {
    const s = encodeURIComponent(search ?? '');
    return this.http.get<RestResponse<Promotion[]>>(
      `${this.baseUrl}/list?search=${s}&page=${page}&paginate=${paginate}`
    );
  }

  getById(id: number): Observable<RestResponse<Promotion>> {
    return this.http.get<RestResponse<Promotion>>(`${this.baseUrl}/find/${id}`);
  }

  create(body: SavePromotionPayload): Observable<RestResponse<{ id: number }>> {
    return this.http.post<RestResponse<{ id: number }>>(`${this.baseUrl}/save`, body);
  }

  update(id: number, body: SavePromotionPayload): Observable<RestResponse<unknown>> {
    return this.http.put<RestResponse<unknown>>(`${this.baseUrl}/update/${id}`, body);
  }

  delete(id: number): Observable<RestResponse<unknown>> {
    return this.http.delete<RestResponse<unknown>>(`${this.baseUrl}/delete/${id}`);
  }
}
